import { render, staticRenderFns } from "./SpeakerModerateIcon.vue?vue&type=template&id=307684c4&"
import script from "./SpeakerModerateIcon.vue?vue&type=script&lang=js&"
export * from "./SpeakerModerateIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports